<template>
  <FormCard
    :filled="filled"
    class="hub-card"
    :class="{ 'hub-card-clickable': clickable }"
    @click="handleClick"
  >
    <template #title>
      <span class="card-title-text">
        {{ title }}
        <font-awesome-icon v-if="filled" icon="circle-check" class="ok-icon" />
      </span>
      <span class="card-header-actions">
        <slot name="actions" />
      </span>
    </template>
    <slot />
  </FormCard>
</template>

<script>
import FormCard from '@/components/formKit/FormCard.vue'

export default {
  name: 'ExecutorHubCard',
  components: { FormCard },
  props: {
    title: { type: String, required: true },
    filled: { type: Boolean, default: false },
    clickable: { type: Boolean, default: false },
  },
  emits: ['click'],
  setup(props, { emit }) {
    const handleClick = (event) => {
      if (!props.clickable) return
      if (event.target.closest('button, input, select, textarea, a, [role="button"]')) return
      emit('click', event)
    }

    return { handleClick }
  },
}
</script>

<style scoped>
.hub-card {
  position: relative;
}

/* Keep an open search dropdown above the cards that follow it in the grid.
 * Clickable cards create their own stacking context because of the hover
 * transform, so the dropdown's z-index alone cannot escape the parent card. */
.hub-card:focus-within {
  z-index: 30;
}

.hub-card-clickable {
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}

.hub-card-clickable:hover {
  border-color: #6366f1;
  box-shadow: 0 12px 28px rgba(99, 102, 241, 0.18);
  transform: translateY(-1px);
}

.hub-card-clickable:hover :deep(.card-arrow) {
  color: #6366f1;
}

.card-title-text {
  align-items: center;
  display: inline-flex;
  gap: 6px;
}

.card-header-actions {
  align-items: center;
  display: inline-flex;
  gap: 6px;
  margin-left: auto;
}

.ok-icon {
  color: #28a745;
  font-size: 14px;
}
</style>
